import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { OnboardingOrchestratorService } from '../../../../core/services/onboarding-orchestrator.service';
import { UpdateService } from '../../../../core/services/update.service';

/**
 * The notification-area counterpart of the onboarding wait screen, in both of the states the user
 * is not watching: the job still running after they closed the modal, and the job having given up
 * while they were elsewhere. The second one is the only way back to the dialog that asks for a
 * corrected address once the session that watched the run is gone.
 */
@Component({
  selector: 'app-onboarding-progress-notification',
  templateUrl: './onboarding-progress-notification.component.html',
  styleUrl: './onboarding-progress-notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingProgressNotificationComponent {
  private readonly orchestrator = inject(OnboardingOrchestratorService);
  private readonly updates = inject(UpdateService);

  readonly isVisible = this.orchestrator.isBackgroundProgressVisible;
  readonly isFailureVisible = this.orchestrator.isBackgroundFailureVisible;
  readonly progressPercent = this.orchestrator.progressPercent;
  readonly caption = this.orchestrator.progressCaption;
  readonly failureHeadline = this.orchestrator.failureHeadline;

  /**
   * The Electron update toast owns the same corner and carries the "Restart Now" button, so this
   * card steps above it while one is on screen rather than burying it.
   */
  readonly offsetForUpdateToast = computed(() => this.updates.updateState() !== 'idle');

  hide(): void {
    this.orchestrator.hideBackgroundProgress();
  }

  hideFailure(): void {
    this.orchestrator.hideBackgroundFailure();
  }

  showFailure(): void {
    this.orchestrator.showFailure();
  }
}
